import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import { useTranslation } from "react-i18next";

import { db, collection, doc, getDoc, addDoc, updateDoc } from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import { useParams } from "react-router-dom";
import AdminSentEmailsFromOrder from "./AdminSentEmailsFromOrder";

import CurrencyFormat from "react-currency-format";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HashLink } from "react-router-hash-link";
import AddNote from "./AddNote";
import AdminCheck from "./AdminCheck";
import emailjs from "@emailjs/browser";

const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  let { id } = useParams();

  let navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState(null);
  const [step, setStep] = useState(2);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [status, setStatus] = useState(null);
  const [reason, setReason] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [delayReason, setDelayReason] = useState(null);
  const [totalQuantity, setTotalQuantity] = useState(0);
  console.log("totalQuantity", totalQuantity);

  const getOrders = async () => {
    setOrders([]);
    const docRef = doc(db, "KO_orders", id);
    const docSnap = await getDoc(docRef);
    setStatus(docSnap.data().status);
    setOrder(docSnap.data());
    console.log("docSnap.data()", docSnap.data());

    let numOfQuantity = 0;

    if (docSnap.data().basket) {
      JSON.parse(docSnap.data().basket).map((item) => {
        console.log("item", item);
        numOfQuantity = numOfQuantity + item.quantity;
      });
    }
    setTotalQuantity(numOfQuantity);

    if (docSnap.exists()) {
      if (docSnap.data().user_uid) {
        const docRef2 = doc(db, "users", docSnap.data().user_uid);
        getDoc(docRef2).then(async (res) => {
          console.log(res.data());

          if (res.data().firstname && res.data().lastname) {
            setOrders((old) =>
              old.concat({
                ...docSnap.data(),
                id: docSnap.data().id,
                firstname: res.data().firstname,
                lastname: res.data().lastname,
              })
            );
          } else {
            setOrders((old) =>
              old.concat({
                ...docSnap.data(),
                id: docSnap.data().id,
              })
            );
          }
        });
      }
    } else {
      navigate("/admin/orders");
    }
  };

  useEffect(() => {
    setTimeout(() => {
      getOrders();
    }, 100);
  }, []);

  console.log(orders);

  console.log(step);
  console.log("status", status); // selected action
  console.log("order.status", order?.status);

  useEffect(() => {
    setStep(1);
  }, []);

  const changeStep = (num) => {
    setStep(num);
  };

  const orderConfirmed = async (orderId) => {
    try {
      const ref = doc(db, "KO_orders", orderId);

      await updateDoc(
        ref,
        {
          status: [...order.status, "Order confirmed"],
        },
        { merge: true }
      );
      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 지연되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );

      changeStep(3);

      alert(
        "발주확인이 완료 되었습니다! 상태 변경이 완료되고 손님에게 이메일을 전송했습니다."
      );
      handleClose();
      changeStep(1);
    } catch (err) {}
  };

  const orderDelayed = async (orderId) => {
    console.log("############### orderDelayed orderId", orderId);
    try {
      const ref = doc(db, "KO_orders", orderId);
      await updateDoc(
        ref,
        {
          status: [...order.status, "Order delayed"],
        },
        { merge: true }
      );
      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 지연되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      alert("배송 지연이 완료 되었습니다!");
    } catch (err) {
      alert("There is an error when processing. Please try again later.");
    }
  };
  const orderCancelled = async (orderId, sendEmail) => {
    try {
      const ref = doc(db, "KO_orders", orderId);
      await updateDoc(
        ref,
        {
          status: [...order.status, "Order cancelled"],
        },
        { merge: true }
      );

      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 지연되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );

      changeStep(3);
      setTimeout(() => {
        handleClose();
        changeStep(1);
      }, 2000);
      window.location.reload(false);
    } catch (error) {
      alert("There is an error when processing. Please try again later.");
    }
  };

  const orderShipped = async (orderId, tracking) => {
    try {
      console.log("tracking", tracking);
      const ref = doc(db, "KO_orders", orderId);
      await updateDoc(
        ref,
        {
          status: [...order.status, "Order shipped"],
          tracking: tracking,
        },
        { merge: true }
      );

      // Send it to the customer
      var templateParams1 = {
        user_email: order.email,
        from_name: order.address_lastname + " " + order.address_firstname,
        lastname: order.address_lastname,
        status: " 지연되었습니다",
        orderId: orderId,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_ub6tfci",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );

      alert("주문 발송으로 상태를 변경했습니다.");

      changeStep(3);
      setTimeout(() => {
        handleClose();
        changeStep(1);
      }, 2000);
      // window.location.reload(false);
    } catch (error) {
      alert("There is an error when processing. Please try again later.");
    }
  };

  const updateShippingInfo = async () => {
    if (status === "Order confirmed") {
      orderConfirmed(id);
    } else if (status === "Order delayed") {
      orderDelayed(id);
    } else if (status === "Order cancelled") {
      orderCancelled(id);
    }
    getOrders();
  };

  const handleOrderShipped = (event) => {
    event.preventDefault();

    let num = Math.ceil(totalQuantity / 20);
    let tracking = [];
    for (let i = 0; i < num * 2; i = i + 2) {
      if (
        event.target[i].value.length > 0 &&
        event.target[i + 1].value.length > 0
      ) {
        tracking.push({
          company: event.target[i].value,
          tracking: event.target[i + 1].value,
        });
      }
    }
    console.log("Trackings...", tracking);
    orderShipped(id, tracking);
  };

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%" }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px", pl: 5, fontWeight: 600 }}>
                  회원 주문 상세 페이지
                </Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  View Details Stats
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "13px",
                }}
              ></Box>
              <Grid container>
                <Grid item md={12} sm={12} xs={12} sx={{ pb: 10 }}>
                  <Box
                    sx={{
                      py: 2,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      px: 4,
                    }}
                  >
                    {orders.map((order, idx) => {
                      console.log("order", order);
                      return (
                        <Box
                          key={idx}
                          className="textBox"
                          style={{
                            marginBottom: "20px",
                            width: "100%",
                            backgroundColor: "white",
                          }}
                        >
                          <Box sx={{ color: "black", fontSize: "14px" }}>
                            <Box
                              sx={{
                                display: "flex",
                                paddingTop: "10px",
                                alignItems: "center",
                              }}
                            ></Box>
                          </Box>
                          <Box>
                            <Typography
                              id="transition-modal-title"
                              component={"span"}
                              variant={"body2"}
                              style={{ fontSize: "15px", fontWeight: 600 }}
                            >
                              주문 내용
                            </Typography>
                            <Typography
                              id="transition-modal-description"
                              sx={{
                                mt: 2,
                                color: "black",
                                lineHeight: "1.9em",
                                fontSize: "13px",
                              }}
                            >
                              <Box>
                                <span style={{}}>
                                  <span className="normal">주문 번호</span>:{" "}
                                  {id},
                                </span>
                                <span>
                                  {" "}
                                  <span className="normal">
                                    주문 날짜
                                  </span>:{" "}
                                  {order?.created &&
                                    order?.created
                                      ?.toDate()
                                      .toLocaleDateString("fr-CA", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })}{" "}
                                  {order?.created &&
                                    order?.created
                                      ?.toDate()
                                      .toLocaleTimeString("ko-KR")}
                                </span>
                              </Box>
                              <div style={{}}>
                                <span className="normal">고객 이름</span>:&nbsp;
                                <span>
                                  {order?.lastname} {order?.firstname}
                                </span>{" "}
                              </div>{" "}
                              <Box>
                                <span className="normal">전화번호</span>:{" "}
                                {order?.phone}
                              </Box>
                              <span>
                                <span className="normal">배송지 주소</span>:{" "}
                              </span>
                              <span
                                style={{
                                  color: "#153a5a",
                                  fontWeight: 800,
                                  textDecoration: "underline",
                                }}
                              >
                                {order?.address_lastname}&nbsp;
                                {order?.address_firstname}
                              </span>
                              &nbsp;
                              {order?.address_address}&nbsp;
                              {order?.address_apt}&nbsp;
                              {order?.address_city}&nbsp;
                              {order?.address_state}&nbsp;
                              {order?.address_zipcode}
                              <br />
                              <span className="normal">배송비:</span>{" "}
                              {order?.shippingPrice}원
                              <br />
                              <span className="normal">총 가격: </span>
                              <CurrencyFormat
                                decimalScale={2}
                                value={order?.finalPrice}
                                displayType={"text"}
                                thousandSeparator={true}
                                suffix={"원"}
                              />
                              <br />
                              <Box
                                sx={{
                                  mt: 2,
                                  border: "1px solid lightgray",
                                  px: 3,
                                  py: 2,
                                }}
                              >
                                <Box sx={{ fontWeight: 800 }}>
                                  결제 상태
                                  <span
                                    style={{
                                      color: "gray",
                                      paddingLeft: "10px",
                                    }}
                                  >
                                    (입금을 확인하셨으면 '발주확인'을
                                    눌러주세요.)
                                  </span>
                                </Box>
                                <Box sx={{ color: "#153a5a" }}>
                                  입금 은행: {order?.payment_status?.bank},
                                  입금자명:{" "}
                                  {order?.payment_status?.customer_name}
                                </Box>
                              </Box>
                              <br />
                              <Box>
                                주문 상태:{" "}
                                <span style={{ color: "blue" }}>
                                  {t(order?.status[order.status.length - 1])}
                                </span>{" "}
                                <Box
                                  sx={{
                                    fontSize: "13px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingBottom: "10px",
                                    marginTop: "10px",
                                  }}
                                >
                                  <Box>
                                    {order?.lastname} {order?.firstname}{" "}
                                    {order?.user_uid && (
                                      <HashLink
                                        className="pink_link"
                                        style={{ textDecoration: "non" }}
                                        to={"/admin/user/" + order?.user_uid}
                                      >
                                        [유저 정보 보기]
                                      </HashLink>
                                    )}
                                    <a
                                      target={"_blank"}
                                      className="pink_link"
                                      href={"mailto:" + order.email}
                                    >
                                      [이메일 보내기]
                                    </a>
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  fontSize: "13px",
                                  pt: 5,
                                  color: "#757575",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  flex: 1,
                                }}
                              >
                                <Box sx={{ pl: 5 }}>
                                  {JSON.parse(order.basket).map((item, idx) => (
                                    <Box
                                      key={idx}
                                      sx={{
                                        color: "black",
                                        fontSize: "12px",
                                        pb: 2,
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={item.image}
                                          alt=""
                                          width="40"
                                        />
                                        <Box sx={{ pl: 2 }}>
                                          {item.quantity}x{" "}
                                          <span style={{}}>{t(item.name)}</span>
                                        </Box>
                                      </Box>
                                    </Box>
                                  ))}
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    minWidth: "200px",
                                    pr: 8,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      fontSize: "13px",
                                      color: "black",
                                      pb: 2,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <CurrencyFormat
                                      value={order.finalPrice}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      suffix={"원"}
                                    />
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Box>{t("Subtotal")}</Box>
                                    <Box>
                                      <CurrencyFormat
                                        decimalScale={2}
                                        value={order.subtotal}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        suffix={"원"}
                                      />
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      pb: 1,
                                    }}
                                  >
                                    <Box>배송비</Box>
                                    <Box>
                                      <CurrencyFormat
                                        decimalScale={2}
                                        value={order.shippingPrice}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        suffix={"원"}
                                      />{" "}
                                    </Box>
                                  </Box>

                                  <Box
                                    sx={{
                                      borderTop: "1px solid lightgray",
                                      pt: 1,
                                    }}
                                  ></Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Box>{t("Total")}</Box>
                                    <Box>
                                      <CurrencyFormat
                                        decimalScale={2}
                                        value={order.finalPrice}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        suffix={"원"}
                                      />
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  pt: 2,
                                  p: 3,
                                  backgroundColor: "#fafafa",
                                  border: "1px solid #e0e0e0",
                                  mr: 2,
                                  ml: 1,
                                  mt: 3,
                                }}
                              >
                                <InventoryOutlinedIcon
                                  sx={{
                                    position: "relative",
                                    top: "+6px",
                                    color: "gray",
                                  }}
                                />{" "}
                                {order.status[order.status.length - 1] ===
                                "Order cancelled" ? (
                                  t(
                                    "Order has been cancelled. This order has closed. "
                                  )
                                ) : order.status[order.status.length - 1] !==
                                  "Order shipped" ? (
                                  <>
                                    <span style={{ fontWeight: "bold" }}>
                                      {t("Change Status")}
                                    </span>
                                    <Box sx={{ mt: 3 }}>
                                      <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                          {t("Order Status")}
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={status}
                                          label="Order Status"
                                          onChange={(e) =>
                                            setStatus(e.target.value)
                                          }
                                          sx={{
                                            width: "300px",
                                            backgroundColor: "white",
                                          }}
                                        >
                                          {order.status[
                                            order.status.length - 1
                                          ] === "Preparing for shipment" ? (
                                            <MenuItem value={"Order confirmed"}>
                                              {t("Order confirmed")}
                                            </MenuItem>
                                          ) : null}

                                          {order.status[
                                            order.status.length - 1
                                          ] === "Order confirmed" ||
                                          order.status[
                                            order.status.length - 1
                                          ] === "Preparing for shipment" ? (
                                            <MenuItem value={"Order delayed"}>
                                              {t("Order delayed")}
                                            </MenuItem>
                                          ) : null}

                                          {order.status[
                                            order.status.length - 1
                                          ] === "Preparing for shipment" ||
                                          order.status[
                                            order.status.length - 1
                                          ] === "Order confirmed" ||
                                          order.status[
                                            order.status.length - 1
                                          ] === "Order delayed" ? (
                                            <MenuItem value={"Order cancelled"}>
                                              {t("Order cancelled")}
                                            </MenuItem>
                                          ) : null}

                                          <MenuItem value={"Order shipped"}>
                                            {t("Order shipped")}
                                          </MenuItem>
                                        </Select>
                                      </FormControl>

                                      {status === "Order delayed" ? (
                                        <Box>
                                          <div>
                                            <Box
                                              sx={{
                                                color: "#283593",
                                                pb: 2,
                                                pt: 2,
                                              }}
                                            >
                                              발송 지연처리는 '1회'만
                                              가능합니다. 이메일을 보내실때 발송
                                              기한을 고객에게 보낼수있습니다.
                                            </Box>
                                            <Box sx={{ minWidth: 120 }}>
                                              <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">
                                                  {t("Reason of the delay")}
                                                </InputLabel>
                                                <Select
                                                  labelId="demo-simple-select-label"
                                                  id="demo-simple-select"
                                                  value={reason}
                                                  label="Age"
                                                  onChange={(e) =>
                                                    setReason(e.target.value)
                                                  }
                                                  sx={{
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  <MenuItem
                                                    value={
                                                      "Preparing for the product"
                                                    }
                                                  >
                                                    {t(
                                                      "Preparing for the product"
                                                    )}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Customer request"}
                                                  >
                                                    {t("Customer request")}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Custom order"}
                                                  >
                                                    {t("Custom order")}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Scheduled shipment"}
                                                  >
                                                    {t("Scheduled shipment")}
                                                  </MenuItem>
                                                  <MenuItem
                                                    value={"Oversea shipment"}
                                                  >
                                                    {t("Oversea shipment")}
                                                  </MenuItem>
                                                  <MenuItem value={"Other"}>
                                                    {t("Other")}
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  width: 1,
                                                  alignItems: "center",
                                                  pt: 2,
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    width: 1 / 2,
                                                    paddingTop: "9px",
                                                  }}
                                                >
                                                  발송 기한
                                                </Box>
                                                <DatePicker
                                                  selected={startDate}
                                                  onChange={(date) =>
                                                    setStartDate(date)
                                                  }
                                                />
                                              </Box>
                                              <Box
                                                sx={{
                                                  width: 1,
                                                  pt: 2,
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    width: 1 / 2,
                                                    paddingTop: "9px",
                                                    mb: 2,
                                                  }}
                                                >
                                                  발송 지연 상세 사유
                                                  (옵션입니다)
                                                </Box>
                                                <TextField
                                                  value={delayReason}
                                                  onChange={(e) =>
                                                    setDelayReason(
                                                      e.target.value
                                                    )
                                                  }
                                                  multiline
                                                  rows={3}
                                                  sx={{
                                                    width: 1,
                                                    backgroundColor: "white",
                                                  }}
                                                />
                                              </Box>
                                            </Box>
                                          </div>
                                        </Box>
                                      ) : null}

                                      {status === "Order shipped" ? (
                                        <Box>
                                          <Box
                                            sx={{
                                              color: "gray",
                                              mt: 1,
                                              fontSize: "13px",
                                            }}
                                          >
                                            {t(
                                              "After submitting, the system will send an automatic email to the user with this notification."
                                            )}{" "}
                                          </Box>

                                          <form onSubmit={handleOrderShipped}>
                                            <Box>
                                              배송 업체를 선택하고 송장 번호를
                                              입력해주세요
                                            </Box>
                                            {Array.from(
                                              Array(
                                                Math.ceil(totalQuantity / 20)
                                              ),
                                              (e, i) => {
                                                return (
                                                  <Box
                                                    sx={{
                                                      mt: 1,
                                                    }}
                                                  >
                                                    <Box
                                                      sx={{
                                                        position: "relative",
                                                        top: "+1px",
                                                        color: "#153a5a",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {t("Shipping2")} {i + 1}
                                                    </Box>
                                                    <Box
                                                      sx={{ display: "flex" }}
                                                    >
                                                      <select
                                                        style={{
                                                          width: "200px",
                                                          height: "40px",
                                                          border:
                                                            "1px solid lightgray",
                                                          paddingLeft: "5px",
                                                        }}
                                                      >
                                                        <option
                                                          value={"CJ대한통운"}
                                                        >
                                                          CJ대한통운
                                                        </option>
                                                        <option
                                                          value={
                                                            "롯데글로벌로지스"
                                                          }
                                                        >
                                                          롯데글로벌로지스
                                                        </option>
                                                        <option value={"한진"}>
                                                          한진
                                                        </option>
                                                        <option
                                                          value={"우체국택배"}
                                                        >
                                                          우체국택배
                                                        </option>
                                                        <option
                                                          value={"로젠택배"}
                                                        >
                                                          로젠택배
                                                        </option>
                                                        <option
                                                          value={
                                                            "CU 편의점택배"
                                                          }
                                                        >
                                                          CU 편의점택배
                                                        </option>
                                                      </select>
                                                      <input
                                                        type={"text"}
                                                        style={{
                                                          width: "300px",
                                                          height: "40px",
                                                          border:
                                                            "1px solid lightgray",
                                                          borderLeft: "none",
                                                          paddingLeft: "15px",
                                                        }}
                                                      />
                                                    </Box>
                                                  </Box>
                                                );
                                              }
                                            )}
                                            <button
                                              style={{
                                                marginTop: "20px",
                                                width: "300px",
                                              }}
                                              className="custom_btn"
                                            >
                                              주문 발송으로 변경하기
                                            </button>
                                          </form>
                                        </Box>
                                      ) : null}
                                      <button
                                        onClick={updateShippingInfo}
                                        style={{
                                          marginTop: "20px",
                                          width: "300px",
                                          display:
                                            status === "Order shipped"
                                              ? "none"
                                              : "inline",
                                        }}
                                        className="custom_btn"
                                      >
                                        {t("Submit")}
                                      </button>
                                    </Box>
                                  </>
                                ) : (
                                  <span style={{ fontWeight: 600 }}>
                                    이 주문은 '주문 발송' 되었습니다
                                    <Box
                                      sx={{
                                        fontWeight: 200,
                                        fontSize: "13px",
                                        pt: 2,
                                      }}
                                    >
                                      주문 운송장 정보:
                                      {order.tracking &&
                                        order.tracking.map((track) => {
                                          return (
                                            <Box>
                                              택배 회사:{" "}
                                              <span style={{ fontWeight: 600 }}>
                                                {track.company}
                                              </span>
                                              , 운송장 번호:{" "}
                                              <span style={{ fontWeight: 600 }}>
                                                {track.tracking}
                                              </span>
                                            </Box>
                                          );
                                          console.log(track);
                                        })}
                                    </Box>
                                  </span>
                                )}
                                {/* & Update Tracking Number */}
                              </Box>
                              <AddNote currentLocation={"KO"} orderId={id} />
                              {/* <AdminSentEmailsFromOrder orderId={id} /> */}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
